const actions = {
  LOAD_PARTY: "LOAD_PARTY",
  FOUND_PARTY: "FOUND_PARTY",
  NOT_FOUND_PARTY: "NOT_FOUND_PARTY",
  NOT_CREATE_PARTY: "NOT_CREATE_PARTY",
  CREATE_PARTY: "CREATE_PARTY",
  LEAVE_PARTY: "LEAVE_PARTY",
  JOIN_PARTY: "JOIN_PARTY",

  SOCKET_ACK_PARTY: "ACK_PARTY",
  SOCKET_NOT_ACK_PARTY: "SOCKET_NOT_ACK_PARTY",

  START_GET_PARTY_REQUEST: "START_GET_PARTY_REQUEST",
  START_CREATE_PARTY_REQUEST: "START_CREATE_PARTY_REQUEST",
  END_CREATE_PARTY_REQUEST: "END_CREATE_PARTY_REQUEST",
  END_GET_PARTY_REQUEST: "END_GET_PARTY_REQUEST",
};

export default actions;
